import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ISearchCollectionSubtitlesRequest } from './search-collection-subtitles-request';
import type { ISearchCollectionSubtitlesResponse } from './search-collection-subtitles-response';
import { searchCollectionSubtitlesResponseSchema } from './search-collection-subtitles-response';

export async function searchCollectionSubtitlesApi({
  collectionId,
  query,
}: ISearchCollectionSubtitlesRequest): Promise<
  IValidatedResponse<ISearchCollectionSubtitlesResponse>
> {
  return getRequest<ISearchCollectionSubtitlesResponse>({
    path: `/sys/collections/${collectionId}/subtitles/search`,
    schema: searchCollectionSubtitlesResponseSchema,
    options: { params: { q: query } },
  });
}
